var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.044 2.86h11.875c.139 0 .277.008.415.026A2.448 2.448 0 0 0 12.457.824L2.691 2.491h-.01a2.45 2.45 0 0 0-1.525.97 3.25 3.25 0 0 1 1.888-.602Zm11.875.89H3.044A2.378 2.378 0 0 0 .669 6.125v7.125a2.378 2.378 0 0 0 2.375 2.375h11.875a2.378 2.378 0 0 0 2.375-2.375V6.125a2.377 2.377 0 0 0-2.375-2.375Zm-1.763 7.125a1.188 1.188 0 1 1 0-2.375 1.188 1.188 0 0 1 0 2.375Z"
  })));
};
export default SvgWallet;